import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";
import {
  Parks_and_gardens_Borough_DATA,
  ParksSquaresLeftMenuList,
} from "../utils/constants";

const tabs = [
  { id: "I", label: "I", active: true },
  { id: "II", label: "II" },
  { id: "III", label: "III" },
  { id: "IV", label: "IV" },
  { id: "V", label: "V" },
  { id: "VI", label: "VI" },
  { id: "VII", label: "VII" },
  { id: "VIII", label: "VIII" },
  { id: "IX", label: "IX" },
  { id: "X", label: "X" },
];

const ParkTable = ({ park }) => {
  const { t } = useTranslation();
  return (
    <>
      <table className="table table-bordered">
        <colgroup>
          <col style={{ width: "120px" }} />
          <col />
          <col style={{ width: "150px" }} />
          <col style={{ width: "150px" }} />
        </colgroup>
        <tbody>
          <tr>
            <td>
              <strong>{t("Name :")}</strong>
            </td>
            <td colSpan={3}>{t(park.name)}</td>
          </tr>
          <tr>
            <td>
              <strong>{t("Ward No :")}</strong>
            </td>
            <td>{park.ward}</td>
            <td>
              {t("Area :")} {park.area}
            </td>
            <td>No. of Mali : {park.mali}</td>
          </tr>
          <tr>
            <td>
              <strong>{t("Amenities :")}</strong>
            </td>
            <td colSpan={3}>{t(park.amenities)}</td>
          </tr>
          <tr>
            <td>
              <strong>{t("Remarks :")}</strong>
            </td>
            <td colSpan={3}>{t(park.remarks)}</td>
          </tr>
        </tbody>
      </table>
      <br />
    </>
  );
};

// Tab content
const ParkTabContent = ({ id, parks, isActive }) => (
  <div
    className={`tab-pane fade ${isActive ? "show active" : ""}`}
    id={`nav-${id}`}
    role="tabpanel"
    aria-labelledby={`nav-${id}-tab`}
  >
    <div className="card-body">
      <div className="mayor-table2">
        {parks.map((park, i) => (
          <ParkTable key={i} park={park} />
        ))}
      </div>
    </div>
  </div>
);

const Parks_and_gardens = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container"></div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {ParksSquaresLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">{t("Parks and Gardens")}</h3>
                  </div>
                  <div className="col-lg-12  about-head1">
                    <h4 className="fontSizeClass">
                      {t(
                        "List of some important Parks maintained by the Kolkata Municipal Corporation"
                      )}
                    </h4>
                    <p className="fontSizeClass text-center font-weight-bold">
                      Borough No.
                    </p>
                    <nav>
                      <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        {tabs.map(({ id, label, active }) => (
                          <button
                            key={id}
                            className={`nav-link ${active ? "active" : ""}`}
                            id={`nav-${id}-tab`}
                            data-toggle="tab"
                            data-target={`#nav-${id}`}
                            type="button"
                            role="tab"
                            aria-controls={`nav-${id}`}
                            aria-selected={active}
                          >
                            {label}
                          </button>
                        ))}
                      </div>
                    </nav>
                    <div className="tab-content" id="nav-tabContent">
                      {Object.entries(Parks_and_gardens_Borough_DATA).map(
                        ([id, parks], index) => (
                          <ParkTabContent
                            key={id}
                            id={id}
                            parks={parks}
                            isActive={index === 0}
                          />
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Parks_and_gardens;
